import type { CapsuleDto } from 'new/stores/capsules/capsules.endpoints';

import { parseLifecycleStatus } from 'new/modules/settings/capsules/domain/capsule.status';
import type { CapsuleSummary } from 'new/modules/settings/capsules/domain/capsule.types';

/**
 * Maps API DTO to domain summary. Call at repository/UI boundaries.
 */
export function capsuleFromDto(dto: CapsuleDto): CapsuleSummary {
  const registeredRaw = dto.registered_at ?? dto.created_at ?? null;

  return {
    id: String(dto.id),
    name: dto.name,
    uid: dto.uid ?? null,
    clusterType: dto.cluster_type ?? '—',
    lifecycle: parseLifecycleStatus(dto.status),
    apiStatus: dto.status,
    registeredIso: registeredRaw || null,
    description: dto.description ?? null,
  };
}
